export default {
  BAD_REQUEST: -1
}
